export const clientInvoiceGenerate = () => {
  return '/client-invoice';
};
